<template>
  <div>
    <Head />
    <div class="wrap">
      <div class="cont">
        <div>
          <h1>Хирургия</h1>
          <div data-aos="zoom-in-down">
            <div class="row row-cols-1 row-cols-md-4 g-4">
              <div class="col">
                <router-link class="lin" to="/extraction">
                  <div class="card h-100">
                    <img src="../assets/hir4.jpg" class="card-img-top" alt="">
                    <div class="card-body">
                      <h5 class="card-title">Удаление зубов</h5>
                      <p class="card-text">
                          
                      </p>
                    </div>
                  </div>
                </router-link>
              </div>
              <div class="col">
                <router-link class="lin" to="/wisdom">
                  <div class="card h-100">
                    <img src="../assets/hir4.jpg" class="card-img-top" alt="">
                    <div class="card-body">
                      <h5 class="card-title">Удаление зубов мудрости</h5>
                      <p class="card-text">
                          
                      </p>
                    </div>
                  </div>
                </router-link>
              </div>
              <div class="col">
                <router-link class="lin" to="/protpreparation">
                  <div class="card h-100">
                    <img src="../assets/prot2.jpg" class="card-img-top" alt="">
                    <div class="card-body">
                      <h5 class="card-title">Подготовка к протезированию зубов</h5>
                      <p class="card-text">
                          
                      </p>
                    </div>
                  </div>
                </router-link>
              </div>
              <div class="col">
                <router-link class="lin" to="/impreparation">
                  <div class="card h-100">
                    <img src="../assets/impl2.jpg" class="card-img-top" alt="">
                    <div class="card-body">
                      <h5 class="card-title">Подготовка к имплантации зубов</h5>
                      <p class="card-text">
                          
                      </p>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import Foot from '@/components/Foot.vue'

export default {
  name: 'SurgeryView',
  components: {
    Head,
    Foot,
  }
}
</script>

<style scoped>

.wrap {
  max-width: 90%;
  margin: 60px auto;
  min-height: 500px;
}

.cont {
  margin: 60px auto;
  margin-bottom: 140px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(520px, 1fr));
}

p {
  width: 95%;
}

@media (max-width: 790px) {

.cont {
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
}

}

</style>

